const RepositoriesTableHeaderLabels = {
  name: "REPOSITORY NAME",
  priority: "PRIORITY",
  uri: "URL"
};

module.exports = RepositoriesTableHeaderLabels;



// WEBPACK FOOTER //
// ./src/js/constants/RepositoriesTableHeaderLabels.js